import type { FaireProductEntity } from "../../entity_types/product";

export const p_yzfmjk55rs: FaireProductEntity = {
  token: "p_yzfmjk55rs",
  type: "product",
  name: "mahjong mat - light pink - hearts (ws)",
  brandToken: "b_gdbsede35t",
  brandName: "margo.rebecca",
  imageUrl:
    "https://cdn.faire.com/fastly/f4e426682c7480f85c7a2685602c7a47abe26f7700a8837f65f373800c739154.jpeg",
  galleryImageUrls: [],
  priceDollars: 40,
  description:
    'The pink margo.rebecca mahjong mat adds a fun pop of color to your game. The light pink mat enhances the overall playing experience and adds a touch of excitement to traditional mahjong. Elevate your game with this vibrant and functional mat!\n\n * 33" square non-sliding mat ',
  tags: [],
  msrpDollars: 80,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:50.583Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
